// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputGrid {
  padding: 10px 15px 30px 15px !important;
}
.checkboxInput {
  display: flex !important;
  align-items: flex-end !important;
  justify-content: flex-start !important;
}
.customerInputGrid {
  padding: 17px 10px;
}

.pInput {
  font-size: var(--normal-text-size);
  font-weight: var(--normal-text-weight);
  line-height: var(--normal-text-line-height);
  transition: all 0.3s ease-out;
}
.disabledInpotColor {
  color: var(--disabled-input-color);
  fill: var(--disabled-input-color);
}
.enabledPInput {
  color: var(--enabled-input-color);
  fill: var(--enabled-input-color);
  border-bottom: var(--enabled-input-border);
}
.disabledPInput {
  color: var(--disabled-input-color);
  fill: var(--disabled-input-color);
  border-bottom: var(--disabled-input-border);
}
.invalidPInput {
  color: var(--invalid-input-color);
  fill: var(--invalid-input-color);
  border-bottom: var(--invalid-input-border);
}
.focusedPInput {
  color: var(--enabled-input-color);
  fill: var(--enabled-input-color);
  border-bottom: var(--focused-input-border);
}
.validPInput {
  color: var(--valid-input-color);
  fill: var(--valid-input-color);
  border-bottom: var(--valid-input-border);
}

.enabledinputPIcon {
  color: var(--enabled-icon-color);
  fill: var(--enabled-icon-color);
}

.inputPLabel {
  transition: all 0.3s ease-out;
  font-weight: var(--normal-text-weight);
}
.enabledinputPLabel {
  color: var(--enabled-input-label-color);
  fill: var(--enabled-input-label-color);
}
.disabledinputPLabel {
  color: var(--disabled-input-label-color);
  fill: var(--disabled-input-label-color);
}
.invalidinputPLabel {
  color: var(--invalid-input-color);
  fill: var(--invalid-input-color);
}
.focusedinputPLabel {
  color: var(--focused-input-color);
  fill: var(--focused-input-color);
}
.validinputPLabel {
  color: var(--valid-input-color);
  fill: var(--valid-input-color);
}
.pLabelUp {
  font-size: var(--small-text-size);
  line-height: var(--small-text-line-height);
}
.pLabelDown {
  font-size: var(--normal-text-size);
  line-height: var(--normal-text-line-height);
}
.pLabelSmall {
  font-size: var(--small-text-size);
  line-height: var(--small-text-line-height);
}
.pLabelPlaceholder {
  font-size: var(--extra-small-text-size);
  line-height: var(--extra-small-text-line-height);
  font-weight: var(--normal-text-weight);
}

.centerizedFlex {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media all and (max-width: 350px) {
  .inputGrid {
    padding: 10px 5px 25px 5px !important;
  }
  .customerInputGrid {
    padding: 17px 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;EAC3C,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;AACA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;EACE,uCAAuC;EACvC,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".inputGrid {\r\n  padding: 10px 15px 30px 15px !important;\r\n}\r\n.checkboxInput {\r\n  display: flex !important;\r\n  align-items: flex-end !important;\r\n  justify-content: flex-start !important;\r\n}\r\n.customerInputGrid {\r\n  padding: 17px 10px;\r\n}\r\n\r\n.pInput {\r\n  font-size: var(--normal-text-size);\r\n  font-weight: var(--normal-text-weight);\r\n  line-height: var(--normal-text-line-height);\r\n  transition: all 0.3s ease-out;\r\n}\r\n.disabledInpotColor {\r\n  color: var(--disabled-input-color);\r\n  fill: var(--disabled-input-color);\r\n}\r\n.enabledPInput {\r\n  color: var(--enabled-input-color);\r\n  fill: var(--enabled-input-color);\r\n  border-bottom: var(--enabled-input-border);\r\n}\r\n.disabledPInput {\r\n  color: var(--disabled-input-color);\r\n  fill: var(--disabled-input-color);\r\n  border-bottom: var(--disabled-input-border);\r\n}\r\n.invalidPInput {\r\n  color: var(--invalid-input-color);\r\n  fill: var(--invalid-input-color);\r\n  border-bottom: var(--invalid-input-border);\r\n}\r\n.focusedPInput {\r\n  color: var(--enabled-input-color);\r\n  fill: var(--enabled-input-color);\r\n  border-bottom: var(--focused-input-border);\r\n}\r\n.validPInput {\r\n  color: var(--valid-input-color);\r\n  fill: var(--valid-input-color);\r\n  border-bottom: var(--valid-input-border);\r\n}\r\n\r\n.enabledinputPIcon {\r\n  color: var(--enabled-icon-color);\r\n  fill: var(--enabled-icon-color);\r\n}\r\n\r\n.inputPLabel {\r\n  transition: all 0.3s ease-out;\r\n  font-weight: var(--normal-text-weight);\r\n}\r\n.enabledinputPLabel {\r\n  color: var(--enabled-input-label-color);\r\n  fill: var(--enabled-input-label-color);\r\n}\r\n.disabledinputPLabel {\r\n  color: var(--disabled-input-label-color);\r\n  fill: var(--disabled-input-label-color);\r\n}\r\n.invalidinputPLabel {\r\n  color: var(--invalid-input-color);\r\n  fill: var(--invalid-input-color);\r\n}\r\n.focusedinputPLabel {\r\n  color: var(--focused-input-color);\r\n  fill: var(--focused-input-color);\r\n}\r\n.validinputPLabel {\r\n  color: var(--valid-input-color);\r\n  fill: var(--valid-input-color);\r\n}\r\n.pLabelUp {\r\n  font-size: var(--small-text-size);\r\n  line-height: var(--small-text-line-height);\r\n}\r\n.pLabelDown {\r\n  font-size: var(--normal-text-size);\r\n  line-height: var(--normal-text-line-height);\r\n}\r\n.pLabelSmall {\r\n  font-size: var(--small-text-size);\r\n  line-height: var(--small-text-line-height);\r\n}\r\n.pLabelPlaceholder {\r\n  font-size: var(--extra-small-text-size);\r\n  line-height: var(--extra-small-text-line-height);\r\n  font-weight: var(--normal-text-weight);\r\n}\r\n\r\n.centerizedFlex {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@media all and (max-width: 350px) {\r\n  .inputGrid {\r\n    padding: 10px 5px 25px 5px !important;\r\n  }\r\n  .customerInputGrid {\r\n    padding: 17px 5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
